import { LoadingScreen } from "components/LoadingScreen";
import { IFiltrosAguardandoPagamento } from "../../../interface/IFiltrosAguardandoPagamento";
import { ContainerFiltros } from "./style";
import { useProcessoFinanceiroAprovar } from "../../../hooks/useProcessoFinanceiroAprovar";
import { useEffect, useState } from "react";
import { FiltrosAprovados } from "./FiltrosAprovados";
import { ListarAprovados } from "./ListarAprovados";

interface IProps {
  aba: string;
}

export function TabAprovadosParaPagamento({ aba }: IProps) {
  const [showModalDetalhesLotePagamento, setShowModalDetalhesLotePagamento] =
    useState<boolean>(false);

  const {
    loading,
    listarAprovados,
    setPage,
    setLimit,
    dadosAprovados,
    totalRows,
    setSelectedRows,
    selectedRows,
    limit,
    idLoteEscolhido,
    buscarEstatisticasLotePagamento,
    buscarEstatisticasPagamento,
    relatorioDetalhado,
    dadosDetalhes,
    onClickProcesso,
    buscarDetalhesLotePagamento,
    setDadosDetalhes,
    setIdLoteEscolhido,
    page,
    filtroListaAprovados,
    confirmarPagamento,
    buscarComprovantes,
    numeroNfReciboEscolhido,
    buscarReciboNf,
    clearRows,
    enviarLotesParaCorrecao,
  } = useProcessoFinanceiroAprovar();

  useEffect(() => {
    if (aba !== "aprovado") return;
    listarAprovados(filtroListaAprovados);
  }, [aba, limit, page, filtroListaAprovados]);

  function handlePageChange(page: number) {
    setPage(page);
  }
  function handleLimitChange(limit: number) {
    setLimit(limit);
  }

  const submitFiltro = (dados: IFiltrosAguardandoPagamento) => {
    listarAprovados(dados);
  };

  const handleCloseModalDetalhes = () => {
    setShowModalDetalhesLotePagamento(false);
    setDadosDetalhes([]);
    setIdLoteEscolhido(null);
  };

  const onClickVerDetalhes = (idLote: number) => {
    setIdLoteEscolhido(idLote);
  };

  useEffect(() => {
    if (idLoteEscolhido) {
      buscarDetalhesLotePagamento();
      setShowModalDetalhesLotePagamento(true);
      return;
    }
  }, [idLoteEscolhido]);

  const onClickVerReciboNf = (idLote: number, numeroNfRecibo: string) => {
    buscarReciboNf(idLote, numeroNfRecibo);
  };

  return (
    <ContainerFiltros>
      <LoadingScreen mostrar={loading} />
      <FiltrosAprovados submitForm={submitFiltro} />
      <ListarAprovados
        dados={dadosAprovados}
        handleLimitChange={handleLimitChange}
        handlePageChange={handlePageChange}
        totalRows={totalRows}
        setRowsSelected={setSelectedRows}
        selectedRows={selectedRows}
        loadingLista={false}
        linhasPorPagina={limit}
        confirmarPagamento={confirmarPagamento}
        showModalDetalhesLotePagamento={showModalDetalhesLotePagamento}
        handleCloseModalDetalhes={handleCloseModalDetalhes}
        numeroNfReciboEscolhido={numeroNfReciboEscolhido}
        onClickVerDetalhes={onClickVerDetalhes}
        buscarEstatisticasLotePagamento={buscarEstatisticasLotePagamento}
        buscarEstatisticasPagamento={buscarEstatisticasPagamento}
        onClickProcesso={onClickProcesso}
        relatorioDetalhado={relatorioDetalhado}
        dadosDetalhes={dadosDetalhes}
        buscarComprovantes={buscarComprovantes}
        onClickVerReciboNf={onClickVerReciboNf}
        clearRows={clearRows}
        enviarLotesParaCorrecao={enviarLotesParaCorrecao}
        aba={aba}
      />
    </ContainerFiltros>
  );
}
